import { render, staticRenderFns } from "./AmioChatWizard.vue?vue&type=template&id=374266f8&"
import script from "./AmioChatWizard.vue?vue&type=script&lang=js&"
export * from "./AmioChatWizard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports